import React, { useState, useEffect } from "react";
import { Box, Stack, LinearProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MEFTiiCOMMImageUpper from '../assets/Images/MEFTiiCOMM-Image-upper-side.png';
import MEFTiiCOMMChatImageCenter from '../assets/Images/MEFTiiCOMM-Chat-Image-center.png';

const LoadingScreen = () => {
  const theme = useTheme();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 200);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.paper,
        zIndex: 9999,
      }}
    >
      <Stack spacing={4} alignItems="center" mb={4}>
        <img src={MEFTiiCOMMImageUpper} alt="MEFTii Communication Logo" style={{ width: "70%", height: 'auto' }} />
        <img src={MEFTiiCOMMChatImageCenter} alt="MEFTii Chat Image" style={{ width: "66%", height: 'auto', borderRadius: 8}} />
      </Stack>

      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          width: 200,
          height: 8,
          borderRadius: 5,
          backgroundColor: theme.palette.grey[300],
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.primary.main,
          },
        }}
      />
    </Box>
  );
};

export default LoadingScreen;